export * from './customer-skeleton';
